<template>
  <div class="result">
    <router-link @click.native="closeSearch()" :to="product.permalink">
      <div class="cart__link__product__image">
        <img
          :src="base_url + product.thumbnail.sized"
          :alt="product.alt"
          class="attachment-thumbnail size-thumbnail"
        />
      </div>
      <div class="cart__link__product__info">
        <div class="cart__link__product__info__text">
          <p class="cart__link__product__title">{{ product.name }}</p>
          <small>
            <strong>{{ translations.sku }}:</strong>
            {{ product.sku }}
          </small>

          <Price
            v-if="product.meta_fields._directo_product_closed != 1"
            :regularPrice="product.regular_price"
            :salePrice="product.sale_price"
          />
        </div>
      </div>
    </router-link>
  </div>
</template>

<style scoped lang="scss">
.result {
  padding: 1.3rem 2rem;
  cursor: pointer;

  &:not(:last-of-type) {
    border-bottom: 0.1rem solid $color-light-gray;
  }

  &:hover {
    background-color: #f7f7f7;
  }

  a {
    display: flex;
    align-items: flex-end;

    &:hover {
      text-decoration: none;
    }
  }
}

.cart__link__product__info {
  flex: 1;
}

.cart__link__product__image {
  width: 12rem;
  height: 12rem;
  display: flex;
  align-items: flex-end;
  justify-items: center;
  margin-right: 2rem;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
}
</style>

<script>
import Price from '@/layouts/general-ui/Price.vue';

export default {
  name: 'WellsSearchResult',
  data() {
    return {
      translations: {
        sku: ws_vue_store.translations.product_SKU,
      },
      base_url: ws_vue_store['site_url'],
    };
  },
  props: {
    product: Object,
  },
  components: {
    Price,
  },
};
</script>
